export default {
  // General
  'saving-plan:general:more-info': 'Meer info',

  // Selector
  'saving-plan:selector:title': 'Jaarvoordeel',
  'saving-plan:selector:none': 'Zonder 0%',
  'saving-plan:selector:none:price': '0€ / jaar',
  'saving-plan:selector:clever': 'Clever {badge}',
  'saving-plan:selector:clever:badge': 'vanaf 3%',
  'saving-plan:selector:clever:price': '2,99€ / jaar',
  'saving-plan:selector:premium': 'Premium {badge}',
  'saving-plan:selector:premium:badge': 'vanaf 5%',
  'saving-plan:selector:premium:price': '7,99€ / jaar',
  'saving-plan:selector:dynamic:badge': '{discount}%',
  'saving-plan:selector:price-info':
    'Voor slechts {price} €: extra {discount}% korting op elke bestelling!',
  'saving-plan:selector:price-info:dynamic':
    'Voor eenmalig {price}: min. {discount}% extra korting per bestelling!',
  'saving-plan:selector:price-info:exact':
    'Voor eenmalig {price}: {discount}% extra korting per bestelling!',

  // Info bar messages
  'saving-plan:info-bar:active':
    'Jouw {planName}-plan is actief - al met {percentage}% korting verlaagd.',
  'saving-plan:info-bar:customer-plan':
    'Jouw jaarvoordeel ({planName}) is actief - minstens {percentage} % korting verzekerd.',
  'saving-plan:info-bar:cart': 'Met jouw gekozen {planName}-plan al {percentage}% goedkoper',
  'saving-plan:info-bar:savings':
    'Jouw jaarvoordeel {planName}: <strong>{amount}</strong> bespaard.',
  'saving-plan:info-bar:account:page': 'Jaarvoordeel {planName} {percentage}%',
  'saving-plan:info-bar:account:page:active-until': 'Actief tot {activeUntil}',
  'saving-plan:info-bar:account:page:more-info': 'Meer info',
  'saving-plan:info-bar:account:page:more-info:label': 'Meer informatie over dit jaarvoordeel',
  'saving-plan:info-bar:subscriptions:page':
    'Jouw bespaarabonnement-producten: {percentage}% goedkoper met jaarvoordeel {planName}',

  // Cart element
  'saving-plan:cart:banner': 'Bespaar nu {amount} bij deze bestelling!',
  'saving-plan:cart:title:clever': 'Jaarvoordeel Clever',
  'saving-plan:cart:title:premium': 'Jaarvoordeel Premium',
  'saving-plan:cart:description': 'Jaarvoordeel: een jaar lang besparen bij elke bestelling',
  'saving-plan:cart:benefit:pay-once': 'Eén keer betalen, 12 maanden besparen',
  'saving-plan:cart:benefit:discount': 'Korting op voer & snacks',
  'saving-plan:cart:benefit:no-renewal': 'Geen automatische verlenging',
  'saving-plan:cart:price:clever': 'Eenmalig 2,99 €',
  'saving-plan:cart:price:premium': 'Eenmalig 7,99 €',
  'saving-plan:cart:activate': 'Nu activeren',
  'saving-plan:cart:pet-profile-benefit': 'Meer besparen met dierprofiel!',
  'saving-plan:cart:increase-discount': 'Korting verhogen',

  // More info sheet
  'saving-plan:more-info:not-active:title': 'Extra korting bij elke bestelling',
  'saving-plan:more-info:active:title': 'Jouw jaarvoordeel uitgelegd',
  'saving-plan:more-info:column:plan': 'Jaarvoordeel',
  'saving-plan:more-info:column:discount': 'Korting',
  'saving-plan:more-info:none': 'Zonder - gratis',
  'saving-plan:more-info:none:discount': '0%',
  'saving-plan:more-info:clever': 'Clever - 2,99 €/jaar',
  'saving-plan:more-info:clever:without-profile': 'Zonder dierprofiel: 3%',
  'saving-plan:more-info:clever:with-profile': 'Met dierprofiel: vanaf 5%',
  'saving-plan:more-info:premium': 'Premium - 7,99 €/jaar',
  'saving-plan:more-info:premium:without-profile': 'Zonder dierprofiel: 5%',
  'saving-plan:more-info:premium:with-profile': 'Met dierprofiel: vanaf 8%',
  'saving-plan:more-info:benefit:duration': '12 maanden prijsvoordeel verzekeren',
  'saving-plan:more-info:benefit:no-renewal': 'Geen automatische verlenging',
  'saving-plan:more-info:benefit:all-products': 'Geldt voor alle voersoorten & snacks',
  'saving-plan:more-info:benefit:one-per-account': 'Eén jaarvoordeel per account',
  'saving-plan:more-info:benefit:combinable': 'Ook te combineren met bespaarabonnement & tegoedbon',
  'saving-plan:more-info:close': 'Sluiten',

  // Login button
  'saving-plan:login-button:already-registered': 'Ben je al geregistreerd?',
  'saving-plan:login-button:login-here': 'Hier aanmelden',

  // Editor
  'saving-plan:editor:title': 'Kies jouw jaarvoordeel',
  'saving-plan:editor:info':
    'Voor slechts {value} €: min. {discount}% extra korting op elke bestelling!',
  'saving-plan:editor:cancel': 'Sluiten',
  'saving-plan:editor:save': 'Selectie opslaan',
  'saving-plan:editor:close': 'Sluiten',
};
